export const fuzzyMatch = (textToSearch: string, searchTerm: string): boolean => {
  const cleanText = textToSearch.toLowerCase();
  const cleanSearch = searchTerm.toLowerCase();

  let searchIdx = 0;
  for (let i = 0; i < cleanText.length; i++) {
    if (cleanText[i] === cleanSearch[searchIdx]) {
      searchIdx++;
    }
    if (searchIdx === cleanSearch.length) {
      return true;
    }
  }
  return cleanSearch.length === 0;
};
